<template>
  <div class="flex flex-col h-full">
    <lerner-header :show-login-form="false" :pending="pending"></lerner-header>
    <page-header title="Register For A Lerner Sports Free Trial"></page-header>
    <RegisterForm v-on:submit="submitRegistration"/>
    <app-footer :pages="pages" class="w-full pin-b"></app-footer>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import AppFooter from '@/component/AppFooter';
  import LernerHeader from '@/component/Header';
  import RegisterForm from './RegisterForm';
  import AuthService from '@/common/services/auth.service';
  import PageHeader from '@/component/PageHeader';
  import { CHANGE_DOC_TITLE, SHOW_NOTIFICATION } from '@/store/actions/app.actions';
  import { getError } from '@/common/services/http.service';

  export default {
    name: 'Register',

    components: {
      PageHeader,
      RegisterForm,
      LernerHeader,
      AppFooter
    },

    data: () => {
      return {
        pending: false
      }
    },

    created: function () {
      this.$store.dispatch(CHANGE_DOC_TITLE, {title: 'Register', useBaseTitle: true})
    },

    computed: {
      ...mapGetters([
        'pages'
      ])
    },

    methods: {
      submitRegistration(registrationData) {
        this.pending = true;

        AuthService.registerUser(registrationData)
          .then(() => this.$router.push({name: 'register-acknowledge'}))
          .catch(e => this.$store.dispatch(SHOW_NOTIFICATION, {type: 'error', message: this.escapeForwardSlashes(getError(e)), timeout: 15000}))
          .finally(() => this.pending = false);
      },
      escapeForwardSlashes(message) {
        return message.replace('\\', '');
      }
    }
  };
</script>
